var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPossibleChallengesImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 17,
    viewBox: "0 0 11 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.509977 10.2207L6.09884 1.13883C6.12781 1.09176 6.20048 1.11675 6.19438 1.17167L5.50646 7.36292C5.50306 7.39358 5.52706 7.4204 5.55791 7.4204H10.442C10.4833 7.4204 10.508 7.46648 10.4851 7.50088L4.9019 15.8756C4.8716 15.9211 4.80069 15.8947 4.80747 15.8405L5.4928 10.3578C5.49666 10.3269 5.47257 10.2996 5.44144 10.2996H0.554063C0.513566 10.2996 0.488752 10.2552 0.509977 10.2207Z",
    fill: "#FB4141",
    stroke: "#F2F2F2",
    strokeWidth: 0.44,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPossibleChallengesImg);
export default __webpack_public_path__ + "static/media/possible-challenges-img.7eeb5ae6b3d32079fd345c0aa589a57d.svg";
export { ForwardRef as ReactComponent };